export default __webpack_public_path__ + "static/media/Documentos-afiliacion-banco-bolivariano.abe38757.pdf";